import { HomeProduct } from '../request';

const HIDDEN_PRODUCT_SLUGS = ['helixa-affinity'];

const isHomeProductDisabled = (product: HomeProduct) =>
  product.enabled === false;

export const mapHomeProducts = (
  products: HomeProduct[] = []
): HomeProduct[] => {
  const visibleProducts = products.filter(
    (product) => !HIDDEN_PRODUCT_SLUGS.includes(product.slug)
  );

  return [
    ...visibleProducts
      .filter((product) => !isHomeProductDisabled(product))
      .sort((a, b) => b.name.localeCompare(a.name)),
    ...visibleProducts.filter(isHomeProductDisabled),
  ];
};
